import React from 'react';
import logo from './logo.svg';

import * as S from './styled';

const App = () => {
  return (
    <S.Container>
      <S.Header>
        <S.Logo src={logo} alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <S.Link href="https://reactjs.org" target="_blank" rel="noopener noreferrer">
          Learn React
        </S.Link>
      </S.Header>
    </S.Container>
  );
};

export default App;
